const routMain = () => '/main';

export default routMain;